import {HTTP} from "../../helpers/axios";
import {AxiosResponse} from "axios";
import { Action } from 'redux'
import {RootState} from '../../reducers'
import { ThunkAction } from 'redux-thunk'
import { serverRoutes} from "../../api/serverRoutes";


export const assignPermissionToRole = (data:object,callback:(error:boolean)=>void):ThunkAction<void, RootState, unknown, Action<string>> => async (dispatch,getState) => {

    try {
        const response =  await   HTTP(getState,dispatch).post(serverRoutes.assignRolePermissions,data);

        dispatch({
            type: 'GET_PERMISSIONS',
            payload: response.data
        });

        let error=false;
        callback(error);

    }catch (e) {
        let error=true;
        callback(error);
    }

};

